/* Calendar-day estimates start from the visitor's local date. */
(() => {
  if (customElements.get('rp-arrival-dates')) return;
  customElements.define('rp-arrival-dates', class extends HTMLElement {
    connectedCallback() {
      if (this.onVisibility) return;
      this.minimum = Number(this.dataset.minDays);
      this.maximum = Number(this.dataset.maxDays);
      if (!Number.isInteger(this.minimum) || !Number.isInteger(this.maximum) || this.minimum < 1 || this.maximum < this.minimum || this.maximum > 365) return;
      this.onVisibility = () => { if (!document.hidden) this.refresh(); };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.refresh();
    }

    refresh() {
      clearTimeout(this.timer);
      const today = new Date();
      const arrivalDate = (days) => {
        const date = new Date(today);
        date.setHours(12, 0, 0, 0);
        date.setDate(date.getDate() + days);
        return date;
      };
      const start = arrivalDate(this.minimum);
      const end = arrivalDate(this.maximum);
      const options = { month: 'short', day: 'numeric' };
      if (start.getFullYear() !== today.getFullYear() || end.getFullYear() !== today.getFullYear()) options.year = 'numeric';
      let formatter;
      try { formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', options); }
      catch (_) { formatter = new Intl.DateTimeFormat('en', options); }
      this.textContent = `${formatter.format(start)} – ${formatter.format(end)}`;
      const tomorrow = new Date(today);
      tomorrow.setHours(24, 0, 0, 250);
      this.timer = setTimeout(() => this.refresh(), tomorrow.getTime() - today.getTime());
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.onVisibility = null;
    }
  });
})();
